export default "__VITE_ASSET__Cjs$S87W__"